import api from './api';

export interface InviteUserData {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  companyId: string;
  role: string;
  designation?: string;
  department?: string;
}

export interface SendInvitationData {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: string;
  permissions?: Array<{
    module: string;
    actions: string[];
  }>;
  designation?: string;
  department?: string;
}

export interface Invitation {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  designation?: string;
  department?: string;
  status: 'pending' | 'accepted' | 'declined' | 'expired';
  expiresAt: string;
  createdAt: string;
  resendCount: number;
  lastSentAt: string;
  invitedBy: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  company?: {
    _id: string;
    name: string;
    logo?: string;
    description?: string;
  };
}

export interface InvitationDetails {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  designation?: string;
  department?: string;
  company: {
    _id: string;
    name: string;
    logo?: string;
    description?: string;
  };
  invitedBy: {
    _id: string;
    firstName: string;
    lastName: string;
  };
  expiresAt: string;
  isNewUser?: boolean;
  hasTemporaryPassword?: boolean;
}

export interface AcceptInvitationData {
  password?: string;
  phone?: string;
  changePassword?: boolean;
}

export const invitationService = {
  // Invite user to company (new centralized endpoint)
  inviteUserToCompany: async (data: InviteUserData) => {
    const response = await api.post('/invitations/invite', data);
    return response.data;
  },

  // Legacy: Send invitation (kept for backward compatibility)
  sendInvitation: async (companyId: string, data: SendInvitationData) => {
    // Convert to new format
    const inviteData: InviteUserData = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      companyId,
      role: data.role,
      designation: data.designation,
      department: data.department
    };
    return invitationService.inviteUserToCompany(inviteData);
  },

  // Get company invitations
  getCompanyInvitations: async (companyId: string, params?: {
    page?: number;
    limit?: number;
    status?: string;
  }) => {
    const response = await api.get(`/invitations/companies/${companyId}/invitations`, { params });
    return response.data;
  },

  // Get invitation details by token
  getInvitationByToken: async (token: string): Promise<{ success: boolean; data: InvitationDetails }> => {
    const response = await api.get(`/invitations/${token}`);
    return response.data;
  },

  // Accept invitation
  acceptInvitation: async (token: string, data: AcceptInvitationData) => {
    const response = await api.post(`/invitations/${token}/accept`, data);
    return response.data;
  },

  // Decline invitation
  declineInvitation: async (token: string) => {
    const response = await api.post(`/invitations/${token}/decline`);
    return response.data;
  },

  // Resend invitation
  resendInvitation: async (invitationId: string) => {
    const response = await api.post(`/invitations/${invitationId}/resend`);
    return response.data;
  },

  // Cancel invitation
  cancelInvitation: async (invitationId: string) => {
    const response = await api.delete(`/invitations/${invitationId}`);
    return response.data;
  },


};